import React, { Component } from 'react';
import { connect } from 'react-redux';
import { pushAndStop, isPlaying } from '../../redux/actions/text.action';
import { setSearchTerm, clearCurrentSearchImage } from '../../redux/actions/result.action';
import { goBack, push } from 'connected-react-router';
import forwardIcon from '../../assets/forwardArrow.png';
import Div100vh from 'react-div-100vh';
import logo from '../../assets/logo.png';

import './Start.scss';
import PrimaryButtonCard from '../../components/PrimaryButtonCard/PrimaryButtonCard';
import { setAvatar } from '../../redux/actions/avatar.action';
import tobiIcon from '../../assets/lebenshilfe_avatar_1a.svg';
import Text2Voice from '../../components/Text2Voice/Text2Voice';

class Start extends Component<{ navigateTo: any, setAvatar: any, allowPlay: any }, { play: boolean }> {
  constructor(props: any) {
    super(props);
    this.state = {
      play: false
    }
  }
  render() {
    return (
      <Div100vh className="start background">
        <img className="avatar" src={tobiIcon} alt="tobi" />
        <h1>Tobi hilft im Internet</h1>
        <PrimaryButtonCard text="Los" icon={forwardIcon} action={() => {
          this.props.allowPlay()
          const avatar = localStorage.getItem('lhgraz_avatar');
          if (avatar) {
            this.props.setAvatar(avatar);
            this.props.navigateTo("/home");
          } else {
            this.props.setAvatar(JSON.stringify({
              "name": "Tobi",
              "img": tobiIcon,
              "voice": "de-AT-Michael",
              "gender": "male"
            }));
            this.props.navigateTo('/selectavatar')
          }
        }} />
        <img src={logo} className="logo" alt="logo" />
      </Div100vh>
    )
  }
}

const mapStateToProps = (state: any) => {
  return {
    searchImage: state.result.currentSearchImage
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    navigateTo(path: string) {
      dispatch(push(path));
    },
    setAvatar(avatar: any) {
      dispatch(setAvatar(avatar));
    },
    allowPlay() {
      dispatch(isPlaying(true));
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Start);